import { ALEClient, type AleKeyProvisioner } from '../aleClient';
import { buildAleMopEnvelope } from '../aleEnvelope';
import { buildMopEncryptionPayload } from './mopPayload';

let aleClient: ALEClient | null = null;
let aleClientProvisioner: AleKeyProvisioner | null = null;

const getAleClient = (provisionKey: AleKeyProvisioner): ALEClient => {
  if (!aleClient || aleClientProvisioner !== provisionKey) {
    aleClient = new ALEClient(provisionKey);
    aleClientProvisioner = provisionKey;
  }
  return aleClient;
};

/** Encrypts a raw MOP using ALE and returns the VERSION 1 COP envelope. */
export const aleEncryptMop = async (
  raw: string,
  mopType: string,
  provisionKey: AleKeyProvisioner,
): Promise<string> => {
  const plaintext = buildMopEncryptionPayload(raw, mopType);
  const { ciphertext, token } = await getAleClient(provisionKey).encrypt(plaintext);
  return buildAleMopEnvelope(ciphertext, token);
};

/** Visible for unit tests. */
export const resetAleClientForTests = () => {
  aleClient = null;
  aleClientProvisioner = null;
};
